import React from "react";
import Button from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useLocation, useNavigate } from "react-router";
import LocationSelectionModal from "./LocationSelectionModal";
import { addLocationSearch, addLocationStepFrom } from "./addLocationRoute";

const styles = {
  button: {
    whiteSpace: 'nowrap'
  }
};

export default function AddLocationButton({ warehouse, onCreated }) {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const location = useLocation();

  // The URL is the single source of truth for whether the modal is open and
  // which step it is on, so both steps are linkable and the browser's back
  // button walks them.
  const step = addLocationStepFrom(location.search);

  const goToStep = (nextStep, { replace = false } = {}) => {
    navigate({ search: addLocationSearch(location.search, nextStep) }, { replace });
  };

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        onClick={() => goToStep("main")}
        sx={styles.button}
      >
        {isMobile ? "Add New" : "Add Location"}
      </Button>
      {step && (
        <LocationSelectionModal
          key={warehouse.id}
          warehouseId={warehouse.id}
          step={step}
          onStepChange={goToStep}
          onClose={() => goToStep(null)}
          // Replace on success: the record exists now, so back should not
          // reopen the form that created it.
          onCreated={() => {
            goToStep(null, { replace: true });
            if (onCreated) onCreated();
          }}
        />
      )}
    </>
  );
}
